import { render, staticRenderFns } from "./consumables.vue?vue&type=template&id=2d0a4322"
import script from "./consumables.ts?vue&type=script&lang=js&external"
export * from "./consumables.ts?vue&type=script&lang=js&external"
import style0 from "./consumables.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports